import { render, staticRenderFns } from "./BergfahrtUhrzeit.vue?vue&type=template&id=8fd0d2ea&scoped=true"
import script from "./BergfahrtUhrzeit.vue?vue&type=script&lang=js"
export * from "./BergfahrtUhrzeit.vue?vue&type=script&lang=js"
import style0 from "./BergfahrtUhrzeit.vue?vue&type=style&index=0&id=8fd0d2ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd0d2ea",
  null
  
)

export default component.exports